import { createRouter, createWebHashHistory } from 'vue-router'
import { useUserStore } from '@/store/user'
import { ElMessage } from 'element-plus'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "Home" */ '@/views/home/Index.vue')
  },
  {
    path: '/404',
    name: '404',
    component: () => import(/* webpackChunkName: "404" */ '@/views/404/Index.vue')
  },
  {
    path: '/userNotPermission',
    name: 'UserNotPermission',
    component: () => import(/* webpackChunkName: "UserNotPermission" */ '@/views/userNotPermission/Index.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "Login" */ '@/views/login/Index.vue')
  },
  {
    path: '/openapi',
    name: 'OpenapiHome',
    component: () => import(/* webpackChunkName: "OpenapiHome" */ '@/views/openapi/Index.vue')
  },
  {
    path: '/openapi/version/:id',
    name: 'OpenapiVersion',
    component: () => import(/* webpackChunkName: "OpenapiVersion" */ '@/views/openapi/Version.vue'),
  },
  {
    path: '/openapi/detail/:id/:vid',
    name: 'OpenapiDetail',
    component: () => import(/* webpackChunkName: "OpenapiDetail" */ '@/views/openapi/Detail.vue'),
    children: [
      {
        path: 'md/:detailId',
        name: 'OpenapiDetailMD',
        component: () => import(/* webpackChunkName: "OpenapiDetailMD" */ '@/views/openapi/components/OpenapiMdView.vue'),
        props: true,
      },
      {
        path: 'api/:detailId',
        name: 'OpenapiDetailAPI',
        component: () => import(/* webpackChunkName: "OpenapiDetailAPI" */ '@/views/openapi/components/OpenapiDocView.vue'),
        props: true,
      },
      {
        path: 'dict/:detailId',
        name: 'OpenapiDetailDict',
        component: () => import(/* webpackChunkName: "OpenapiDetailDict" */ '@/views/openapi/components/OpenapiDictView.vue'),
        props: true,
      },
    ],
  },
  {
    path: '/openapi/detail/atp/:id/:vid',
    name: 'OpenapiDetailATP',
    component: () => import(/* webpackChunkName: "OpenapiDetail" */ '@/views/openapi/atpApi/ATPDetail.vue'),
    children: [
      {
        path: 'md/:detailId',
        name: 'OpenapiDetailATPMD',
        component: () => import(/* webpackChunkName: "OpenapiDetailMD" */ '@/views/openapi/components/OpenapiMdView.vue'),
        props: true,
      },
      {
        path: 'api/:detailId',
        name: 'OpenapiDetailATPAPI',
        component: () => import(/* webpackChunkName: "OpenapiDetailAPI" */ '@/views/openapi/atpApi/components/ATPOpenapiDocView.vue'),
        props: true,
      },
      {
        path: 'dict/:detailId',
        name: 'OpenapiDetailATPDict',
        component: () => import(/* webpackChunkName: "OpenapiDetailDict" */ '@/views/openapi/components/OpenapiDictView.vue'),
        props: true,
      },
    ],
  },
  {
    path: '/openapi/detail/kcbp/:id/:vid',
    name: 'OpenapiDetailKCBP',
    component: () => import(/* webpackChunkName: "OpenapiDetail" */ '@/views/openapi/newKcbp/KCBPDetail.vue'),
    children: [
      {
        path: 'md/:detailId',
        name: 'OpenapiDetailKCBPMD',
        component: () => import(/* webpackChunkName: "OpenapiDetailKCBPMD" */ '@/views/openapi/components/OpenapiMdView.vue'),
        props: true,
      },
      {
        path: 'api/:detailId',
        name: 'OpenapiDetailKCBPAPI',
        component: () => import(/* webpackChunkName: "OpenapiDetailKCBPAPI" */ '@/views/openapi/newKcbp/components/KCBPOpenapiDocView.vue'),
        props: true,
      },
      {
        path: 'dict/:detailId',
        name: 'OpenapiDetailKCBPDict',
        component: () => import(/* webpackChunkName: "OpenapiDetailDict" */ '@/views/openapi/components/OpenapiDictView.vue'),
        props: true,
      },
    ],
  },
  {
    path: '/system',
    name: 'System',
    component: () => import(/* webpackChunkName: "System" */ '@/views/system/components/Layout.vue'),
    children: [
      {
        path: '/system/index',
        name: 'SystemIndex',
        component: () => import(/* webpackChunkName: "SystemIndex" */ '@/views/system/views/Index.vue'),
        meta: {
          // routePermissionFlag: 'systemSetting',
          requiresAuth: true,
        }
      },
      {
        path: '/system/detail',
        name: 'SystemDetail',
        component: () => import(/* webpackChunkName: "SystemDetail" */ '@/views/system/views/Detail.vue'),
        meta: {
          // routePermissionFlag: 'systemSetting',
          requiresAuth: true,
        }
      },
      {
        path: '/system/applyList',
        name: 'SystemApplyList',
        component: () => import(/* webpackChunkName: "SystemApplyList" */ '@/views/system/views/ApplyList.vue'),
        meta: {
          // routePermissionFlag: 'systemSetting',
          requiresAuth: true,
        }
      },
      {
        path: '/system/enterprise',
        name: 'SystemEnterprise',
        component: () => import(/* webpackChunkName: "SystemEnterprise" */ '@/views/system/views/Enterprise.vue'),
        meta: {
          // routePermissionFlag: 'systemSetting',
          requiresAuth: true,
        }
      },
      {
        path: '/system/authAppDetail',
        name: 'AuthAppDetail',
        component: () => import(/* webpackChunkName: "AuthAppDetail" */ '@/views/system/components/AuthAppDetail.vue'),
        meta: {
          // routePermissionFlag: 'systemSetting',
          requiresAuth: true,
        }
      },
    ]
  },
  {
    path: '/icons',
    name: 'Icons',
    component: () => import(/* webpackChunkName: "Icons" */ '@/views/icons/Index.vue')
  },
  {
    path: '/:pathMatch(.*)',
    redirect: '404'
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})


router.beforeEach(async (to, from, next) => {
  const userStore = useUserStore()
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  // 需要请求用户信息的路由名单（其他都不请求）
  const checkList = ['/openapi', '/system']
  const isCheckList = checkList.find((item) => to.path.match(item));
  if (isCheckList) {
    // console.log('0 userStore.userData=', userStore.userData)
    await userStore.getUserInfo()
  }

  const hasLogin = userStore.userData

  if (requiresAuth && !hasLogin) {
    // 如果需要登录，则跳转到无权限提示页
    ElMessage.warning('无权限访问此页面，请登录后再试')
    await new Promise((resolve) => setTimeout(resolve, 500))
    next('/login')
  } else {
    // 其他情况均放行
    next()
  }
})
export default router
